var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-container"},[_c('img',{attrs:{"src":_vm.$t('summaryView.section_USP.iconUrl'),"width":"48"}}),_c('h2',{staticClass:"icon-description"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }